import { kycDocumentsTypesLocales } from '@shinetools/kyc-validation';
import LocalizedStrings from 'localized-strings';

import { KycReviewDocumentType } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    file: 'File',
    uploadFailureMessage:
      'Upload failed. Please check your connection and try again',
    uploadTitle: {
      [KycReviewDocumentType.IdRectoHost]:
        'Drag and drop the front of your host’s ID',
      [KycReviewDocumentType.IdVersoHost]:
        'Drag and drop the back of your host’s ID',
      [KycReviewDocumentType.ResidencePermitRectoHost]:
        'Drag and drop the front of your host’s residence permit',
      [KycReviewDocumentType.ResidencePermitVersoHost]:
        'Drag and drop the back of your host’s residence permit',
      [KycReviewDocumentType.PassportHost]:
        'Drag and drop your host’s passport',
      [KycReviewDocumentType.ProofOfAccommodation]:
        'Drag and drop your proof of accommodation',
      default: 'Drag and drop to upload your document',
    },
    ...kycDocumentsTypesLocales.en,
  },
  fr: {
    file: 'Fichier',
    uploadFailureMessage:
      'Le téléchargement a échoué. Veuillez vérifier votre connexion et réessayer.',
    uploadTitle: {
      [KycReviewDocumentType.IdRectoHost]:
        'Déposez ici le recto de la carte d’identité',
      [KycReviewDocumentType.IdVersoHost]:
        'Déposez ici le verso de la carte d’identité',
      [KycReviewDocumentType.ResidencePermitRectoHost]:
        'Déposez ici le recto du titre de séjour',
      [KycReviewDocumentType.ResidencePermitVersoHost]:
        'Déposez ici le verso du titre de séjour',
      [KycReviewDocumentType.PassportHost]: 'Déposez ici le passeport',
      [KycReviewDocumentType.ProofOfAccommodation]:
        'Déposez ici l’attestation d’hébergement',
      default: 'Déposez votre document ici',
    },
    ...kycDocumentsTypesLocales.fr,
  },
} as const);

export default locales;
